<div id="greeting" class="flex-cell">
    <div id="hello">
        <span>{{ contentType }}</span>
    </div>
    <div id="welcomeBack">
        <span></span>
    </div>
</div>

<div class="dashboard-content-sec user-filter-space">
    <div class="card mb-0">
        <app-breadcrumb [crumbList] = "crumbList"></app-breadcrumb>
        <div class="user-heading-sec">
            <div class="mr-4 d-inline-block">
                <span class="p-2" href="#">
                        {{this.total}} {{ contentType }}</span>
            </div>
          
        </div>

        <div class="table-responsive">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table user-table" >
                <thead>
                    <tr>
                        <th *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                            <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                            <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                            <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i> {{header.text}}
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByTitle($event)"/>
                            </div>
                        </th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let con of contentList">
                        <tr (click)="openContent(con.ID)">
 
                            <td >
                                <a href="javascrpt:void(0);" [routerLink]="['/content/'+contentUrl + '/', con.ID]">
                                    {{con.Title}}
                                </a>
                            </td>
                            <td >
                                <a href="javascrpt:void(0);" [routerLink]="['/content/'+contentUrl + '/', con.ID]">
                                    {{con.EffDate}}
                                </a>
                            </td>
                        </tr>

                    </ng-container>
                </tbody>

                <ng-container *ngIf="contentList?.length == 0">
                  <tr><td colspan="2">No Result Found</td></tr>
                </ng-container>



            </table>
            <div class="has-text-centered align-items-end">
                <ul *ngIf="pager.pages && pager.pages.length && pager.pages.length>1" class="pagination">
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
